<template>
  <teleport to="body">
    <transition name="modal-fade">
      <div v-if="modal" class="modal-overlay" @click="onBackdrop">
        <BaseModal
          :modal="modal"
          @close="modalStore.close(modal.id)"
          @confirm="modalStore.confirm(modal.id)"
          @cancel="modalStore.cancel(modal.id)"
          @submit="modalStore.submit(modal.id, $event)"
        />
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { computed } from 'vue'
import { useModalStore } from '@/stores/modalStore'
import BaseModal from './BaseModal.vue'

const modalStore = useModalStore()
const modal = computed(() => modalStore.top)

function onBackdrop() {
  if (!modal.value?.dismissible || !modal.value?.closeOnBackdrop) return
  modalStore.close(modal.value.id)
}
</script>

<style>
/* Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-overlay.modal-blocking {
  background-color: rgba(0, 0, 0, 0.7);
  cursor: not-allowed;
}

.modal-overlay.modal-programmatic {
  background-color: rgba(0, 0, 0, 0.85);
  cursor: not-allowed;
}

/* Transitions overlay */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-to,
.modal-fade-leave-from {
  opacity: 1;
}

/* 🎯 Animation de la modal (slideIn depuis le haut) */
.modal-fade-enter-active .modal {
  animation: slideIn 0.3s ease;
}

.modal-fade-leave-active .modal {
  animation: slideOut 0.3s ease;
}

/* 🎯 Keyframes pour l'effet "venir du haut" */
@keyframes slideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-50px);
    opacity: 0;
  }
}
</style>
